export const NOTICE_NODE_NAME = 'container_notice';
export const NOTICE_TOOLTIP_NAME = 'notice-tooltip';
